export const DASHBOARD_USERS_LOAD = 'DASHBOARD_USERS_LOAD';
export const DASHBOARD_USERS_LOAD_SUCCESS = 'DASHBOARD_USERS_LOAD_SUCCESS';
export const DASHBOARD_USERS_LOAD_ERROR = 'DASHBOARD_USERS_LOAD_ERROR';
export const DASHBOARD_USERS_ADD = 'DASHBOARD_USERS_ADD';
export const DASHBOARD_USERS_ADD_SUCCESS = 'DASHBOARD_USERS_ADD_SUCCESS';
export const DASHBOARD_USERS_ADD_ERROR = 'DASHBOARD_USERS_ADD_ERROR';
export const DASHBOARD_USERS_UPDATE = 'DASHBOARD_USERS_UPDATE';
export const DASHBOARD_USERS_UPDATE_SUCCESS = 'DASHBOARD_USERS_UPDATE_SUCCESS';
export const DASHBOARD_USERS_UPDATE_ERROR = 'DASHBOARD_USERS_UPDATE_ERROR';
export const DASHBOARD_USERS_DELETE = 'DASHBOARD_USERS_DELETE';
export const DASHBOARD_USERS_DELETE_SUCCESS = 'DASHBOARD_USERS_DELETE_SUCCESS';
export const DASHBOARD_USERS_DELETE_ERROR = 'DASHBOARD_USERS_DELETE_ERROR';
